module.exports = __webpack_public_path__ + "static/media/projectinprogress.7e5d040e.PNG";